import { urlBuilder } from '@makemydeal/dr-common-utils';
import { SERVICE_BFF } from './constants';

export function buildBffApiUrl(
    { service = SERVICE_BFF, endPoint = 'init' }: { service?: string; endPoint?: string },
    bff?: any
): string {
    if (service !== SERVICE_BFF) {
        throw new Error('CMD buildBffApiUrl does not support services other than "bff"');
    }
    return urlBuilder.buildFromConfig(bff, endPoint);
}
